import { useCallback } from "react";
import { useMutation } from "@apollo/client/react";
import { logger } from "utils/logger";
import { CANCEL_LEARNING_REQUEST_FLOW } from "utils/queries";
import { CancelLearningRequestWorkflow } from "utils/graphql/CancelLearningRequestWorkflow";

let cancelLoading = false;

export const useCancelLearningRequest = () => {
  const [cancelLearningRequestFlow] = useMutation<CancelLearningRequestWorkflow>(
    CANCEL_LEARNING_REQUEST_FLOW,
  );

  const cancel = useCallback(async () => {
    if (cancelLoading) return false;

    try {
      cancelLoading = true;
      const { data } = await cancelLearningRequestFlow();
      logger.info("New Learning request cancelled successfully", {
        workflowId: data?.cancelLearningRequestWorkflow?.workflowId ?? null,
        message: data?.cancelLearningRequestWorkflow?.message ?? null,
      });
      return true;
    } catch (error) {
      logger.error("Failed to cancel new learning request", {
        error: error instanceof Error ? error.message : String(error),
      });
      return false;
    } finally {
      cancelLoading = false;
    }
  }, [cancelLearningRequestFlow]);

  const isCancelling = useCallback(() => cancelLoading, []);

  return { cancel, isCancelling } as const;
};
